import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

export const BASE_CSS = {
  SCROLLBARS: {
    SMALL: 'small-scrollbar',
  },
};

/**
 * Override styles for global style
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiCssBaselineStyle = (theme: Theme): ThemeStyle => {
  return {
    '@global': {
      'html, body, #app': {
        width: '100%',
        height: '100%',
      },
      html: {
        WebkitFontSmoothing: 'auto',
      },
      body: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility',
        fontWeight: theme.typography.fontWeightRegular,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize,
        lineHeight: theme.typography.lineHeight,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
      },
      'h1,h2,h3,h4,h5,ul,p': {
        margin: 0,
        padding: 0,
      },
      'a:hover': {
        color: theme.props.productColors.default,
        cursor: 'pointer',
      },
      button: {
        fontFamily: theme.typography.fontFamily,
      },

      '::-webkit-input-placeholder': {
        color: theme.palette.grey['300'],
      },

      '::-webkit-scrollbar': {
        width: 20,
        background: 'transparent',
      },
      '::-webkit-scrollbar-button': {
        display: 'none',
      },
      '::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '::-webkit-scrollbar-track-piece': {
        background: 'transparent',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'rgba(0,0,0,0.4)',
        borderRadius: 10,
        border: '5px solid rgba(0, 0, 0, 0)',
        backgroundClip: 'padding-box',
      },
      '::-webkit-scrollbar-corner': {
        display: 'none',
      },
      '::-webkit-scrollbar-resizer': {
        background: 'transparent',
      },

      [`.${BASE_CSS.SCROLLBARS.SMALL}`]: {
        '&::-webkit-scrollbar': {
          width: 10,
        },

        '&::-webkit-scrollbar-thumb': {
          borderWidth: 3,
        },
      },

      'input[type=search]': {
        /* clears the 'X' from Internet Explorer */
        '&::-ms-clear': {
          display: 'none',
          width: 0,
          height: 0,
        },
        '&::-ms-reveal': {
          display: 'none',
          width: 0,
          height: 0,
        },

        /* clears the 'X' from Chrome */
        '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
          display: 'none',
        },
      },
    },
  };
};
